import React from "react";

const LOGOS = ["Amazon", "Alibaba", "Walmart", "Shopify", "DHL", "Maersk"];

export function LogoMarquee() {
  return (
    <section className="border-y border-slate-200 bg-mist py-8" data-testid="logo-marquee">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <p className="mb-6 text-center text-xs uppercase tracking-[0.25em] text-slate-400">
          Trusted by buyers shipping to 47+ countries
        </p>
        <div className="flex flex-wrap items-center justify-center gap-x-12 gap-y-4">
          {LOGOS.map((l) => (
            <span key={l} className="font-heading text-xl font-bold tracking-tight text-slate-400/80">
              {l}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
